<!--
 * @Author: xiaokun
 * @Date: 2020-02-27 09:39:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-22 11:25:30
 * @Description: 问题库 tab
 -->

<template>
  <div class="question-bank">
    <div class="left-side">
      <div class="left-title">
        问题分类
      </div>
      <div class="left-menu">
        <common-tree
          ref="commonTree"
          :apis="apis"
          @node-click="onNodeClick"
          @on-delete-menu="onDeleteMenu"
          @on-modify-menu="onModifyMenu"
          @update-data="treeInit"
          @tree-init="treeInit"
        />
      </div>
    </div>
    <div
      v-loading="tableIsLoading"
      class="right-side"
    >
      <div
        class="right-side-content"
        :class="{'is-batch': isBatch}"
      >
        <!-- 面包屑 -->
        <div class="crumbs">
          <div class="crumbs-left">
            <span class="first-level">全部问题</span>
            <span class="crumb-txt">
              <span
                v-for="(item, index) in crumbData"
                :key="index"
              >
                <ds-iconfont icon-class="icon-mk-right"></ds-iconfont>{{ item }}
              </span>
            </span>
          </div>
          <div
            v-if="viewPart"
            class="crumbs-right"
          >
            <staff-popover
              width="356"
              :list="list"
            />
          </div>
        </div>
        <!-- 搜索栏 -->
        <div class="search-state">
          <div class="search-state-content">
            <!-- 关键词 -->
            <mk-select
              v-model="searchCondition.keyWords"
              placeholder="关键词（可多选）"
              multiple
              clearable
              filterable
              width="200px"
              @change="onSelectChange"
            >
              <mk-option
                v-for="item in keywordOptions"
                :key="item._id"
                :label="item.name"
                :value="item.name"
              >
              </mk-option>
            </mk-select>
            <!-- 商品标签 -->
            <mk-select
              v-model="searchCondition.commodityTags"
              class="mr-l-10"
              placeholder="商品标签（可多选）"
              multiple
              clearable
              filterable
              width="200px"
              @change="onSelectChange"
            >
              <mk-option
                v-for="item in commodityTagsOptions"
                :key="item._id"
                :label="item.name"
                :value="item.name"
              >
              </mk-option>
            </mk-select>
            <mk-input
              v-model="searchCondition.title"
              class="mr-l-10 input-title"
              placeholder="请输入问题名称/回答"
              clearable
              width="200"
              @input="onInput"
            >
            </mk-input>
          </div>
          <!-- <mk-button-biz
          type="primary"
          class="add-new"
          width="100px"
          @click="addNewQuestion"
        >
          <mk-iconfont icon-class="xinzeng" />
          <span class="add-new-text">新增问题</span>
        </mk-button-biz> -->
          <div class="btn-group">
            <mk-button-biz
              v-show="isAdminOrManage"
              width="58px"
              height="32px"
              :disabled="isBatch"
              @click="isBatch=true"
            >
              批量
            </mk-button-biz>
            <!-- 更多操作 -->
            <mk-dropdown @command="handleCommandMenu">
              <mk-button-biz
                class="more-options"
                width="70px"
                :disabled="isBatch"
              >
                更多<i class="el-icon-arrow-down el-icon--right" />
              </mk-button-biz>
              <mk-dropdown-menu slot="dropdown">
                <mk-dropdown-item
                  v-show="isAdminOrManage"
                  command="export"
                >
                  导入问题
                </mk-dropdown-item>
                <mk-dropdown-item command="keyword">
                  关键词管理
                </mk-dropdown-item>
                <mk-dropdown-item command="commodityTag">
                  商品标签管理
                </mk-dropdown-item>
              </mk-dropdown-menu>
            </mk-dropdown>
            <!-- 原 导入问题 -->
            <!-- <mk-button-biz
              v-show="jugeAdminOrManage"
              class="export-xlsx"
              width="100px"
              :disabled="isBatch"
              @click="exportClick"
            >
              <mk-iconfont icon-class="xinzeng" />
              <span class="add-new-text">导入问题</span>
            </mk-button-biz> -->
            <mk-button-biz
              type="primary"
              class="add-new"
              width="100px"
              :disabled="isBatch"
              @click="addNewQuestion"
            >
              <mk-iconfont icon-class="xinzeng" />
              <span class="add-new-text">新增问题</span>
            </mk-button-biz>
          </div>
        </div>
        <!-- 问题列表 -->
        <div class="main-table">
          <mk-table
            v-if="tableMaxHeight"
            ref="table"
            :max-height="tableMaxHeight"
            :data="tableData"
            style="width: 100%;"
            :class="{'no-permission-table': isNoPermission}"
            @selection-change="selectionChange"
          >
            <mk-table-column
              v-if="isBatch"
              type="selection"
              width="50"
            />
            <!-- 问题 -->
            <mk-table-column
              label="问题"
              min-width="200"
              fixed
            >
              <template v-slot="scope">
                <mk-popover
                  v-if="!isBatch"
                  :width="500"
                  placement="top-start"
                  trigger="hover"
                  popper-class="question-bank-popover question-bank-popover-another"
                >
                  <div>
                    <div class="pop-title">
                      问题详情
                    </div>
                    <div class="answer">
                      <div class="item">
                        <span class="item-left">问题：</span>
                        <span>{{ scope.row.title }}</span>
                      </div>
                      <div class="item item-answer">
                        <span class="item-left">答案：</span>
                        <pre v-html="scope.row.answer" />
                      <!-- <span>{{ scope.row.answer }}</span> -->
                      </div>
                    </div>
                  </div>
                  <p
                    slot="reference"
                    class="question-name ellipsis"
                  >
                    {{ scope.row.title }}
                  </p>
                </mk-popover>
                <p
                  v-else
                  class="question-name ellipsis"
                >
                  {{ scope.row.title }}
                </p>
              </template>
            </mk-table-column>
            <!-- 关键词 -->
            <mk-table-column
              label="关键词"
              width="350"
            >
              <template v-slot="scope">
                <div>
                  <span
                    v-for="(keyword, index) in scope.row.keyWords.slice(0,3)"
                    :key="index"
                    class="key-words-item"
                  >
                    {{ keyword }}
                  </span>
                  <span v-if="scope.row.keyWords.length > 3">
                    <keyword-popover
                      :keyword-list="scope.row.keyWords"
                      :is-batch="isBatch"
                      width="270"
                    />
                  </span>
                </div>
              </template>
            </mk-table-column>
            <!-- 商品标签 -->
            <mk-table-column
              label="商品标签"
              width="350"
            >
              <template v-slot="scope">
                <div>
                  <span
                    v-for="(commodityTags, index) in scope.row.commodityTags.slice(0,3)"
                    :key="index"
                    class="key-words-item commodity-tag-item"
                  >
                    {{ commodityTags }}
                  </span>
                  <span v-if="scope.row.commodityTags.length > 3">
                    <keyword-popover
                      :is-commodity="true"
                      :keyword-list="scope.row.commodityTags"
                      :is-batch="isBatch"
                      width="270"
                    />
                  </span>
                </div>
              </template>
            </mk-table-column>
            <!-- 最近更新时间 -->
            <mk-table-column
              prop="updateTime"
              label="最近更新时间"
              width="160"
            >
            </mk-table-column>
            <mk-table-column
              label="操作"
              width="100"
              fixed="right"
            >
              <template v-slot="scope">
                <!-- <span
                  class="operate"
                  @click="editQuestion(scope.row)"
                >编辑</span> -->
                <mk-button-biz
                  type="text"
                  :disabled="isBatch"
                  @click="editQuestion(scope.row)"
                >
                  编辑
                </mk-button-biz>
                <mk-popover
                  :ref="`popover-${scope.$index}`"
                  placement="top"
                  trigger="click"
                  popper-class="question-bank-delete-confirm"
                >
                  <div>
                    <div class="mention-text">
                      <mk-iconfont icon-class="guanbihuojingshihuocuowu" />确定要删除此问题吗？
                    </div>
                    <div class="button">
                      <mk-button-biz
                        width="50px"
                        height="24px"
                        @click="confirmDeleteQuestion(scope.row._id),$refs[`popover-${scope.$index}`].$children[0].doClose()"
                      >
                        确定
                      </mk-button-biz>
                      <mk-button-biz
                        width="50px"
                        height="24px"
                        type="primary"
                        @click="$refs[`popover-${scope.$index}`].$children[0].doClose()"
                      >
                        取消
                      </mk-button-biz>
                    </div>
                  </div>
                  <mk-button-biz
                    slot="reference"
                    type="text"
                    :disabled="isBatch"
                    style="margin-left: 8px;"
                  >
                    删除
                  </mk-button-biz>
                </mk-popover>
              </template>
            </mk-table-column>
            <template
              v-if="isNoPermission"
              v-slot:empty
            >
              <no-data place-holder="暂无权限查看，请联系管理员" />
            </template>
          </mk-table>
        </div>
        <div class="pagination">
          <!-- <div class="total">
          共{{ total }}条
        </div> -->
          <mk-pagination
            :current-page.sync="page"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </mk-pagination>
        </div>
      </div>

      <handle-batch
        v-if="isBatch"
        :config="batchConfig"
        :total="total"
        :select-num="selectList.length"
        @cancel="cancelBatch"
        @move="moveBatch"
        @delete="deleteBatch"
        @select-all="selectAllBatch"
        @edit-keyword="editKeywordBatch"
        @edit-goods-tag="editGoodsTagBatch"
      />
    </div>
    <add-new-question
      :visible.sync="visible"
      :current-menu-id="currentMenuId"
      :is-edit="isEdit"
      :is-subimit="isSubimit"
      :current-qustion-id="currentQustionId"
      :question-form="questionForm"
      @on-success="onAddQuestionSuccess"
      @on-modify="onModifyQuestionSuccess"
      @on-success-add-keyword="onSuccessAddKeyword"
      @on-success-add-tags="onSuccessAddTags"
    ></add-new-question>
    <export-success
      v-if="exportSuccessShow"
      @continue="continueClick"
      @close="close"
    />
    <export-fail
      v-if="exportFailShow"
      :error-msg="errorMsg"
      @continue="continueClick"
      @close="close"
    />
    <export-content
      v-if="exportContentShow"
      type="question"
      @close="close"
      @upload-success="uploadSuccess"
      @upload-fail="uploadFail"
    />
    <key-words
      v-if="keyWordsShow"
      :options="keywordOptions"
      :loading="keyWordsLoading"
      @cancel="cancel"
      @confirm="confirmKeyWords"
    />
    <goods-tag
      v-if="goodsTagShow"
      :loading="goodsTagLoading"
      :options="commodityTagsOptions"
      @cancel="cancel"
      @confirm="confirmGoodsTag"
    />
    <move
      v-if="moveShow"
      :options="treeData"
      :loading="moveLoading"
      :tree-init-ids="treeInitIds"
      @cancel="cancel"
      @confirm="confirmMove"
    />

    <!-- 关键词管理/商品标签管理弹窗 -->
    <common-setting-drawer
      :visible.sync="settingVisible"
      :is-setting-type="isSettingType"
      :keyword-options="keywordOptions"
      :tags-options="commodityTagsOptions"
      @on-confirm-update-commodity-tag="onConfirmUpdateCommodityTag"
      @on-confirm-update-keyword="onConfirmUpdateKeyword"
      @handel-on-update-table-data="handelOnUpdateTableData"
    />
    <mk-dialog-confirm
      :visible.sync="isShowConfirmDialog"
      v-bind="confirmDialogData"
      append-to-body
      @on-confirm="onConfirm"
    />
  </div>
</template>

<script>
import KeywordPopover from '../keyword-popover'
import StaffPopover from '../staff-popover'
import AddNewQuestion from '../add-new-question'
import CommonTree from '../common-tree'
import exportSuccess from '../export/success'
import exportFail from '../export/fail'
import exportContent from '../export/content'
import NoData from '@components/no-data'
import handleBatch from '@components/handle-batch'
import keyWords from '../key-words'
import goodsTag from '../goods-tag'
import move from '../move'
import CommonSettingDrawer from '../common-setting-drawer'

import { ACCOUNTAPIS, CONVERSATIONAPIS } from '@api'
export default {
  name: 'QuestionBank',
  components: {
    AddNewQuestion,
    CommonTree,
    KeywordPopover,
    exportSuccess,
    exportFail,
    exportContent,
    StaffPopover,
    NoData,
    handleBatch,
    keyWords,
    goodsTag,
    move,
    CommonSettingDrawer
  },
  props: {
    commodityTagsOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      isShowConfirmDialog: false,
      confirmDialogData: {
        title: '确认要删除选中项吗？',
        tip: '删除后无法恢复',
        iconColor: 'rgb(245, 34, 45)',
        iconClass: 'guanbihuojingshihuocuowu',
        closeBtn: {
          type: 'default',
          color: '#595959',
          text: '取 消',
          isShow: true
        },
        confirmBtn: {
          type: 'primary',
          color: '#fff',
          text: '确认',
          isShow: true
        }
      },
      tableMaxHeight: 0,
      exportSuccessShow: false,
      exportFailShow: false,
      exportContentShow: false,
      errorMsg: '',
      // table的数据
      tableData: [],
      // 添加问题弹窗是否可见
      visible: false,
      page: 1,
      total: 0,
      keywordOptions: [],
      crumbData: [],
      // 当前搜索的菜单的id
      currentMenuId: 'const-question-tree-root-id',
      // 列表是否正在加载
      tableIsLoading: false,
      // 搜索条件
      searchCondition: {
        commodityTags: [],
        keyWords: [],
        title: ''
      },
      inputTimer: null,
      // 是否是编辑问题
      isEdit: false,
      // 是否允许新建/编辑提交，避免快速点击后二次提交
      isSubimit: false,
      // 当前正在编辑的问题的id
      currentQustionId: '',
      questionForm: {
        answer: '',
        title: '',
        keyWords: [],
        commodityTags: []
      },
      // tree用到的api
      apis: {
        get: CONVERSATIONAPIS.QuestionsApi.pQuestionTreeGet,
        patch: CONVERSATIONAPIS.QuestionsApi.pQuestionTreePatch,
        delete: CONVERSATIONAPIS.QuestionsApi.pQuestionTreeDelete,
        post: CONVERSATIONAPIS.QuestionsApi.pQuestionTreePost
      },
      // 是否是指定员工查看
      viewPart: false,
      // 用于显示已选员工和部门
      list: [],
      // 是否无权限查看内容
      isNoPermission: false,
      isAdminOrManage: false,
      isBatch: false, // 是否为批量操作
      batchConfig: [ // 批量操作数据
        {
          icon: 'iconic_move',
          name: '移动',
          event: 'move'
        },
        {
          icon: 'iconbianji1',
          name: '编辑关键词',
          event: 'edit-keyword'
        },
        {
          icon: 'iconbianji1',
          name: '编辑商品标签',
          event: 'edit-goods-tag'
        },
        {
          icon: 'icon-mk-shanchu1',
          name: '删除',
          event: 'delete'
        }
      ],
      selectList: [], // 批量操作选择列数据
      keyWordsShow: false, // 显示/隐藏关键词
      keyWordsLoading: false, // loading状态
      goodsTagShow: false, // 显示/隐藏商品标签
      goodsTagLoading: false, // loading状态
      treeData: [], // 节点树数据
      moveShow: false,
      moveLoading: false,
      treeInitIds: [],
      // 关键词/商品标签管理弹窗
      settingVisible: false,
      // 管理弹窗类型 关键词/商品标签
      isSettingType: ''
    }
  },
  created () {
    this.jugeAdminOrManage()
    this.pQuestionShowPost()
    this.pKeywordGet()
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.main-table', this)
    })
  },
  methods: {
    treeInit (data) {
      this.treeData = [data]
      this.handleInit(this.treeData)
      this.treeInitIds = [data._id]
    },
    handleInit (arr) {
      if (arr instanceof Array) {
        arr.forEach(item => {
          if (item.children.length === 0) {
            delete item.children
          } else {
            this.handleInit(item.children)
          }
        })
      }
    },
    cancel () {
      this.keyWordsShow = false
      this.goodsTagShow = false
      this.moveShow = false
    },
    confirmMove (data) {
      this.moveLoading = true
      this.pQuestionBatchParentPatch(data)
    },
    confirmKeyWords (data) {
      this.keyWordsLoading = true
      this.pQuestionBatchKeywordsPatch(data)
    },
    confirmGoodsTag (data) {
      this.goodsTagLoading = true
      this.pQuestionBatchCommodityTagsPatch(data)
    },
    // 批量移动
    async pQuestionBatchParentPatch (parent) {
      let ids = this.selectList.map(item => item._id)
      const { success, code } = await CONVERSATIONAPIS.QuestionsApi.pQuestionBatchParentPatch({
        ids: ids,
        parent: parent
      })
      if (success && code === 500200) {
        this.$message.success('移动成功')
        this.moveShow = false
        this.moveLoading = false
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009004) {
        this.$message.error('目录不存在')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.moveShow = false
          this.moveLoading = false
          this.isBatch = false
        })
      } else if (code === 50009003) {
        this.$message.error('当前有人正在编辑，请稍后重试')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.moveShow = false
          this.moveLoading = false
          this.isBatch = false
        })
      } else if (code === 50009005) {
        this.$message.error('没有权限执行此操作')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.moveShow = false
          this.moveLoading = false
          this.isBatch = false
        })
      }
    },
    // 批量编辑关键词
    async pQuestionBatchKeywordsPatch (data) {
      let ids = this.selectList.map(item => item._id)
      const { success, code } = await CONVERSATIONAPIS.QuestionsApi.pQuestionBatchKeywordsPatch({
        ids: ids,
        keyWords: data
      })
      if (success && code === 500200) {
        this.$message.success('设置成功')
        this.keyWordsShow = false
        this.keyWordsLoading = false
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009004) {
        this.$message.error('目录不存在')
        this.$nextTick(() => {
          this.keyWordsShow = false
          this.keyWordsLoading = false
          this.isBatch = false
        })
      } else if (code === 50009003) {
        this.$message.error('当前有人正在编辑，请稍后重试')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.keyWordsShow = false
          this.keyWordsLoading = false
          this.isBatch = false
        })
      } else if (code === 50009005) {
        this.$message.error('没有权限执行此操作')
        this.$nextTick(() => {
          this.keyWordsShow = false
          this.keyWordsLoading = false
          this.isBatch = false
        })
      }
    },
    // 批量编辑商品标签
    async pQuestionBatchCommodityTagsPatch (data) {
      let ids = this.selectList.map(item => item._id)
      const { success, code } = await CONVERSATIONAPIS.QuestionsApi.pQuestionBatchCommodityTagsPatch({
        ids: ids,
        commodityTags: data
      })
      if (success && code === 500200) {
        this.$message.success('设置成功')
        this.isBatch = false
        this.goodsTagShow = false
        this.goodsTagLoading = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009004) {
        this.$message.error('目录不存在')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.isBatch = false
          this.goodsTagShow = false
          this.goodsTagLoading = false
        })
      } else if (code === 50009003) {
        this.$message.error('当前有人正在编辑，请稍后重试')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.isBatch = false
          this.goodsTagShow = false
          this.goodsTagLoading = false
        })
      } else if (code === 50009005) {
        this.$message.error('没有权限执行此操作')
        this.$refs.table.clearSelection()
        this.$nextTick(() => {
          this.isBatch = false
          this.goodsTagShow = false
          this.goodsTagLoading = false
        })
      }
    },
    // 取消批量选择
    cancelBatch () {
      this.$refs.table.clearSelection()
      this.$nextTick(() => {
        this.isBatch = false
      })
    },
    // 批量操作 - 移动
    moveBatch (e) {
      if (this.selectList.length > 0) {
        this.moveShow = true
      } else {
        this.$message.warning('请至少选择一项')
      }
    },
    // 批量操作 - 删除
    deleteBatch () {
      if (this.selectList.length > 0) {
        this.isShowConfirmDialog = true
      } else {
        this.$message.warning('请至少选择一项')
      }
    },
    onConfirm () {
      this.pQuestionBatchDelete()
    },
    async pQuestionBatchDelete () {
      let ids = this.selectList.map(item => item._id)
      const { success, code } = await CONVERSATIONAPIS.QuestionsApi.pQuestionBatchDelete({
        ids: ids
      })
      if (success && code === 500200) {
        this.isShowConfirmDialog = false
        this.$message.success('删除成功')
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009004) {
        this.isShowConfirmDialog = false
        this.$message.success('目录不存在')
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009003) {
        this.isShowConfirmDialog = false
        this.$message.success('当前有人正在编辑，请稍后重试')
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else if (code === 50009005) {
        this.isShowConfirmDialog = false
        this.$message.success('没有权限执行此操作')
        this.isBatch = false
        this.page = 1
        this.pQuestionShowPost(true)
        this.pKeywordGet()
        this.$emit('update')
      } else {
        this.isShowConfirmDialog = false
      }
    },
    // 批量操作 - 全选
    selectAllBatch (e) {
      if (e) this.$refs.table.toggleAllSelection(true)
      else this.$refs.table.clearSelection()
    },
    // 编辑关键词
    editKeywordBatch () {
      if (this.selectList.length > 0) {
        this.keyWordsShow = true
      } else {
        this.$message.warning('请至少选择一项')
      }
    },
    editGoodsTagBatch () {
      if (this.selectList.length > 0) {
        this.goodsTagShow = true
      } else {
        this.$message.warning('请至少选择一项')
      }
    },
    // 表格checkbox change事件
    selectionChange (e) {
      this.selectList = e
    },
    // 成功弹窗 点击继续导入
    continueClick () {
      this.exportSuccessShow = false
      this.exportFailShow = false
      this.exportContentShow = true
    },
    // 更多操作 菜单点击事件
    handleCommandMenu (command) {
      if (command === 'export') {
        this.exportClick()
      } else {
        // 打开关键词 商品标签管理弹窗
        this.handleOnSettingClick(command)
      }
    },
    // 打开关键词 商品标签管理弹窗
    handleOnSettingClick (val) {
      this.isSettingType = val
      this.settingVisible = true
    },
    // 商品标签 删除/编辑/新增操作 操作成功  更新商品列表
    onConfirmUpdateCommodityTag () {
      this.$emit('change-tags-options')
      this.handelOnUpdateTableData()
    },
    // 关键词 删除/编辑/新增操作 操作成功   更新关键词列表
    onConfirmUpdateKeyword () {
      this.pKeywordGet()
      this.handelOnUpdateTableData()
    },
    // 导入点击事件
    exportClick () {
      this.exportContentShow = true
    },
    // 关闭事件
    close () {
      this.exportSuccessShow = false
      this.exportFailShow = false
      this.exportContentShow = false
    },
    // 上传成功
    uploadSuccess (val) {
      this.exportContentShow = false
      this.exportSuccessShow = true
      // 将新的树结构传入树形结构，用于左侧树新增红点的展示
      this.$refs.commonTree.updateTreeData(val.tree)

      this.page = 1
      this.pQuestionShowPost(true)
      this.pKeywordGet()
      this.$emit('update')
    },
    // 上传失败
    uploadFail (errorMsg) {
      this.exportContentShow = false
      this.exportFailShow = true
      this.errorMsg = errorMsg
    },
    // 节点被点击时候搜索问题
    onNodeClick (data) {
      if (data.level === 0) {
        this.treeInitIds = [this.treeInitIds[0], data._id]
      } else if (data.level === 1) {
        this.treeInitIds = [this.treeInitIds[0], data._id]
      } else if (data.level === 2) {
        this.treeInitIds = [this.treeInitIds[0], this.treeInitIds[1], data._id]
      } else if (data.level === 3) {
        this.treeInitIds = [this.treeInitIds[0], this.treeInitIds[1], this.treeInitIds[2], data._id]
      }
      let { level, _id } = data
      if (this.currentMenuId === _id) return
      this.currentMenuId = _id
      this.crumbData = data.treeSource ? data.treeSource : []
      this.viewPart = data.viewPart
      this.list = [...data.deptInfo, ...data.userInfo]
      this.queryWithNoData()
    },
    // 返回右侧面包屑
    getCrumb (data) {
      let { level, _id } = data
    },
    deleteMenu () {
      this.isShowConfirmDialog = true
    },
    // 新增问题
    addNewQuestion () {
      this.isEdit = false
      // 是否允许提交，避免二次点击
      this.isSubimit = true
      this.currentQustionId = ''
      this.questionForm = {
        answer: '',
        title: '',
        keyWords: [],
        commodityTags: []
      }
      this.visible = true
    },
    // 添加问题
    editQuestion (data) {
      this.isEdit = true
      // 是否允许提交，避免二次点击
      this.isSubimit = true
      this.currentQustionId = data._id
      this.questionForm = {
        answer: data.answer,
        title: data.title,
        keyWords: data.keyWords,
        commodityTags: data.commodityTags
      }
      this.visible = true
    },
    // 添加问题成功时
    onAddQuestionSuccess () {
      // 是否允许提交，避免二次点击
      this.isSubimit = false
      this.queryWithNoData()
    },
    // 修改问题成功时
    onModifyQuestionSuccess () {
      // 是否允许提交，避免二次点击
      this.isSubimit = false
      this.pQuestionShowPost()
    },
    // 确认删除问题
    async confirmDeleteQuestion (_id) {
      let params = { _id }
      let res = await CONVERSATIONAPIS.QuestionsApi.pQuestionDelete(params)
      if (res.success) {
        this.$message.success('删除成功')
        this.pQuestionShowPost()
      } else {
        this.$message.error('删除失败')
      }
    },
    // 切换munu，不传条件搜索
    queryWithNoData () {
      this.page = 1
      this.searchCondition.title = ''
      this.searchCondition.keyWords = []
      this.searchCondition.commodityTags = []
      this.pQuestionShowPost()
    },
    // 下拉框选择时候
    onSelectChange () {
      this.page = 1
      this.pQuestionShowPost()
    },
    // 搜索框输入时候
    onInput () {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        this.page = 1
        this.pQuestionShowPost()
      }, 500)
    },
    // 获取表格数据
    async pQuestionShowPost (state) {
      if (!state) this.tableIsLoading = true
      let params = {
        page: this.page,
        pageSize: 10,
        parent: this.currentMenuId,
        title: this.searchCondition.title,
        keyWords: this.searchCondition.keyWords,
        commodityTags: this.searchCondition.commodityTags
      }
      let res = await CONVERSATIONAPIS.QuestionsApi.pQuestionShowPost(params)
      if (!state) this.tableIsLoading = false
      if (res.success) {
        // 无权限查看
        if (res.code === 50009001) {
          this.tableData = []
          this.page = 1
          this.total = 0
          this.isNoPermission = true
        } else {
          let { data, total, page } = res.data
          this.tableData = data
          this.page = page
          this.total = total
          this.isNoPermission = false
        }
      } else {
        this.$error.error('查询失败')
      }
    },
    // 获取关键字
    async pKeywordGet () {
      let res = await CONVERSATIONAPIS.KeyWordApi.pKeywordGet({})
      if (res.success) {
        this.keywordOptions = res.data.data
      }
    },
    // 关键词添加成功时候，筛选条件更新
    onSuccessAddKeyword (data) {
      this.handelOnUpdateTableData()
      this.keywordOptions = data
    },
    // 商品标签添加成功时候，提交至父级，筛选条件更新
    onSuccessAddTags (data) {
      this.handelOnUpdateTableData()
      this.$emit('change-tags-options', data)
    },
    // 分页
    handleCurrentChange () {
      this.pQuestionShowPost()
    },
    // 当menu删除成功时候，判断当前显示的是否是删除的menu下面的问题，如果是，则返回全部问题
    onDeleteMenu (id) {
      if (this.currentMenuId === id) {
        this.currentMenuId = 'const-question-tree-root-id'
        this.crumbData = []
        this.queryWithNoData()
      }
    },
    // 当更新文件夹名称时候，右侧crumb需要更新
    onModifyMenu (resData) {
      this.deepFindCrumbData(this.currentMenuId, resData)
    },
    deepFindCrumbData (id, data) {
      if (data._id === id) {
        this.crumbData = data.treeSource
        this.list = [...data.deptInfo, ...data.userInfo]
        this.viewPart = data.viewPart
      }
      if (data.children && data.children.length > 0) {
        data.children.forEach((item) => {
          this.deepFindCrumbData(id, item)
        })
      }
    },
    // 判断是不是超级管理员和管理员
    // async jugeAdminOrManage () {
    //   const { success, data } = await ACCOUNTAPIS.RoleApi.v1RoleGetGet()
    //   if (success) {
    //     if (data.Type === 'manage' || data.Type === 'admin') {
    //       this.isAdminOrManage = true
    //     } else {
    //       this.isAdminOrManage = false
    //     }
    //   } else {
    //     this.isAdminOrManage = false
    //   }
    //   // const user = JSON.parse(window.localStorage.getItem('user'))
    //   // if (user && (user.identity === 'admin' || user.identity === 'manage')) {
    //   //   this.isAdminOrManage = true
    //   // } else {
    //   //   this.isAdminOrManage = false
    //   // }
    // },

    jugeAdminOrManage () {
      const pcFuncLimits = JSON.parse(localStorage.getItem('user')).roleLimits.pcFuncLimits
      let i = 0
      let len = pcFuncLimits.length
      let state = false
      for (i; i < len; i++) {
        if (pcFuncLimits[i] === 'func_contentSpeechManage') {
          state = true
          break
        }
      }
      this.isAdminOrManage = state
    },

    // 更新表格数据
    handelOnUpdateTableData () {
      this.pQuestionShowPost()
    }
  }
}
</script>

<style lang="scss" scoped>
.question-bank {
  height: 100%;
  display: flex;

  .btn-group {
    display: flex;
    align-items: center;
    margin-left: 10px;

    .more-options {
      margin: 0 8px;
    }
  }

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }

  .left-side {
    height: 100%;
    width: 265px;
    border-right: 1px solid #e8e8e8;

    .left-title {
      font-weight: 500;
      font-size: 14px;
      padding-left: 22px;
      height: 54px;
      line-height: 54px;
      border-bottom: 1px solid #e8e8e8;
    }

    .left-menu {
      height: calc(100% - 55px);
      overflow-y: auto;
    }
  }

  .right-side {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;

    .right-side-content {
      height: 100%;
      padding: 0 16px;
      display: flex;
      flex-direction: column;
    }

    .right-side-content.is-batch {
      height: calc(100% - 52px);
    }

    .handle-batch {
      flex-shrink: 0;
    }

    .crumbs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      line-height: 22px;
      padding: 10px 0;
      // min-height: 58px;

      .crumbs-left {
        margin-right: 20px;

        .first-level {
          color: #262626;
          font-weight: 500;
        }

        .icon-mk-right {
          padding: 0 8px;
          font-size: 12px;
          color: #d9d9d9;
        }

        .crumb-txt {
          color: #595959;
        }
      }

      .crumbs-right {
        flex-shrink: 0;
      }
    }

    .search-state {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .search-state-content {
        display: flex;
        align-items: center;
      }

      .mr-l-10 {
        margin-left: 10px;
      }

      .input-title {
        line-height: 0 !important;
      }
    }

    .add-new.el-button {
      padding: 5px 12px;
      font-size: 13px;
    }

    .add-new {
      .icon-mk-xinzeng {
        color: #fff;
        font-size: 13px;
      }

      .add-new-text {
        padding-left: 8px;
      }
    }

    .export-xlsx {
      .icon-mk-xinzeng {
        font-size: 13px;
        color: #606266;
      }

      .add-new-text {
        font-size: 13px;
        padding-left: 8px;
        color: #606266;
      }

      &:hover {
        .icon-mk-xinzeng,
        .add-new-text {
          color: #009cff;
        }
      }
    }

    /deep/ .export-xlsx.is-disabled {
      .icon-mk-xinzeng {
        color: #c0c4cc !important;
        border-color: #ebeef5 !important;
      }

      .add-new-text {
        color: #c0c4cc !important;
        border-color: #ebeef5 !important;
      }
    }
  }

  .main-table {
    margin-top: 10px;
    flex: 1;
    height: 100%;
    overflow-y: auto;

    .no-permission-table {
      height: 100%;

      /deep/ .el-table__body-wrapper {
        height: calc(100% - 54px);
      }
    }

    .question-name {
      font-size: 13px;
      color: #009cff;
      cursor: pointer;
    }

    .key-words-item {
      display: inline-block;
      box-sizing: border-box;
      font-size: 12px;
      padding: 0 8px;
      background-color: #f3f3f3;
      color: #595959;
      margin-right: 8px;
      border-radius: 2px;
    }

    .commodity-tag-item {
      background-color: #e6f2ff;
      color: #409fff;
    }

    .operate {
      font-size: 13px;
      color: #009cff;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .pagination {
    height: 77px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .total {
      color: #6d7278;
      font-size: 13px;
    }

    .mk-pagination {
      margin-top: 0;
    }
  }

  /deep/ .el-tag__close {
    background-color: transparent;
  }
}
</style>

<style lang="scss">
.question-bank-popover {
  padding: 0;
  width: 256px;

  pre {
    margin: 0;
    font-family: inherit;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .pop-title {
    padding: 0 16px;
    height: 30px;
    line-height: 30px;
    color: #262626;
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  }

  .pop-input {
    margin-top: 11px;
    padding: 0 16px;
  }

  .pop-button {
    margin-top: 15px;
    border-top: 1px solid rgba(0, 0, 0, 0.09);
    padding: 14px 16px;
    text-align: right;
  }
}

.question-bank-popover-another {
  width: 320px;

  .answer {
    font-size: 13px;
    padding: 8px 16px 24px;
    max-height: 450px;
    overflow: auto;

    .item {
      display: flex;
      color: #595959;
      line-height: 18px;

      .item-left {
        flex-shrink: 0;
      }
    }

    .item-answer {
      // display: flex;
      // align-items: flex-start;
      margin-top: 11px;
    }
  }
}

.question-bank-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-mk-guanbihuojingshihuocuowu {
      font-size: 14px;
      color: #f5222d;
      margin-right: 8px;
    }
  }

  .button {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
